// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","ctaButtons":"SectionHero_ctaButtons__iT+Ty","secondaryCtaButton":"SectionHero_secondaryCtaButton__ZS02e"};